import React, { createContext, useContext, useRef } from 'react'
import { useStore } from 'react-redux'

// Create the DiagramService context
const DiagramServiceContext = createContext(null)

/**
 * Custom hook to access the diagram service from context
 * @returns {React.MutableRefObject} The diagram service ref
 */
export const useDiagramService = () => {
  const context = useContext(DiagramServiceContext)
  if (!context) {
    console.warn('useDiagramService must be used within a DiagramServiceProvider')
    return { current: null }
  }
  return context
}

/**
 * Provider component that manages the diagram service instance
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @returns {JSX.Element} The provider component
 */
export const DiagramServiceProvider = ({ children }) => {
  const diagramServiceRef = useRef(null)
  useStore()

  return <DiagramServiceContext.Provider value={diagramServiceRef}>{children}</DiagramServiceContext.Provider>
}

// Need to pass getState function to DiagramController constructor
// Example: new DiagramController(dispatch, store.getState)

export default DiagramServiceContext
